// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file contact_manager_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact } from "./contact_pb";
import { file_contact } from "./contact_pb";
import type { Employee } from "./employee_pb";
import { file_employee } from "./employee_pb";
import type { ContactFilter } from "./contact_filter_pb";
import { file_contact_filter } from "./contact_filter_pb";
import type { EditorTemplate } from "./editor_template_pb";
import { file_editor_template } from "./editor_template_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file contact_manager_service.proto.
 */
export const file_contact_manager_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_contact, file_employee, file_contact_filter, file_editor_template]);

/**
 * ContactService
 *
 * @generated from message grpc.api.v1.ContactRequest
 */
export type ContactRequest = Message<"grpc.api.v1.ContactRequest"> & {
  /**
   * @generated from field: grpc.api.v1.Contact contact = 1;
   */
  contact?: Contact | undefined;

  /**
   * @generated from field: grpc.api.v1.Employee employee = 3;
   */
  employee?: Employee | undefined;
};

/**
 * Describes the message grpc.api.v1.ContactRequest.
 * Use `create(ContactRequestSchema)` to create a new message.
 */
export const ContactRequestSchema: GenMessage<ContactRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 0);

/**
 * @generated from message grpc.api.v1.ContactIdRequest
 */
export type ContactIdRequest = Message<"grpc.api.v1.ContactIdRequest"> & {
  /**
   * @generated from field: int64 id = 2;
   */
  id: bigint;

  /**
   * @generated from field: grpc.api.v1.Employee employee = 3;
   */
  employee?: Employee | undefined;
};

/**
 * Describes the message grpc.api.v1.ContactIdRequest.
 * Use `create(ContactIdRequestSchema)` to create a new message.
 */
export const ContactIdRequestSchema: GenMessage<ContactIdRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 1);

/**
 * @generated from message grpc.api.v1.ContactListRequest
 */
export type ContactListRequest = Message<"grpc.api.v1.ContactListRequest"> & {
};

/**
 * Describes the message grpc.api.v1.ContactListRequest.
 * Use `create(ContactListRequestSchema)` to create a new message.
 */
export const ContactListRequestSchema: GenMessage<ContactListRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 2);

/**
 * @generated from message grpc.api.v1.ContactResponse
 */
export type ContactResponse = Message<"grpc.api.v1.ContactResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Contact contact = 1;
   */
  contact?: Contact | undefined;
};

/**
 * Describes the message grpc.api.v1.ContactResponse.
 * Use `create(ContactResponseSchema)` to create a new message.
 */
export const ContactResponseSchema: GenMessage<ContactResponse> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 3);

/**
 * @generated from message grpc.api.v1.ContactListResponse
 */
export type ContactListResponse = Message<"grpc.api.v1.ContactListResponse"> & {
  /**
   * @generated from field: grpc.api.v1.Contact contact = 1;
   */
  contact?: Contact | undefined;
};

/**
 * Describes the message grpc.api.v1.ContactListResponse.
 * Use `create(ContactListResponseSchema)` to create a new message.
 */
export const ContactListResponseSchema: GenMessage<ContactListResponse> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 4);

/**
 * ContactFilterService
 *
 * @generated from message grpc.api.v1.ContactFilterRequest
 */
export type ContactFilterRequest = Message<"grpc.api.v1.ContactFilterRequest"> & {
  /**
   * @generated from field: grpc.api.v1.ContactFilter contactFilter = 1;
   */
  contactFilter?: ContactFilter | undefined;
};

/**
 * Describes the message grpc.api.v1.ContactFilterRequest.
 * Use `create(ContactFilterRequestSchema)` to create a new message.
 */
export const ContactFilterRequestSchema: GenMessage<ContactFilterRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 5);

/**
 * @generated from message grpc.api.v1.ContactFilterIdRequest
 */
export type ContactFilterIdRequest = Message<"grpc.api.v1.ContactFilterIdRequest"> & {
  /**
   * @generated from field: int64 id = 2;
   */
  id: bigint;
};

/**
 * Describes the message grpc.api.v1.ContactFilterIdRequest.
 * Use `create(ContactFilterIdRequestSchema)` to create a new message.
 */
export const ContactFilterIdRequestSchema: GenMessage<ContactFilterIdRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 6);

/**
 * @generated from message grpc.api.v1.ContactFilterListRequest
 */
export type ContactFilterListRequest = Message<"grpc.api.v1.ContactFilterListRequest"> & {
};

/**
 * Describes the message grpc.api.v1.ContactFilterListRequest.
 * Use `create(ContactFilterListRequestSchema)` to create a new message.
 */
export const ContactFilterListRequestSchema: GenMessage<ContactFilterListRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 7);

/**
 * @generated from message grpc.api.v1.ContactFilterResponse
 */
export type ContactFilterResponse = Message<"grpc.api.v1.ContactFilterResponse"> & {
  /**
   * @generated from field: grpc.api.v1.ContactFilter contactFilter = 1;
   */
  contactFilter?: ContactFilter | undefined;
};

/**
 * Describes the message grpc.api.v1.ContactFilterResponse.
 * Use `create(ContactFilterResponseSchema)` to create a new message.
 */
export const ContactFilterResponseSchema: GenMessage<ContactFilterResponse> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 8);

/**
 * @generated from message grpc.api.v1.ContactFilterListResponse
 */
export type ContactFilterListResponse = Message<"grpc.api.v1.ContactFilterListResponse"> & {
  /**
   * @generated from field: grpc.api.v1.ContactFilter contactFilter = 2;
   */
  contactFilter?: ContactFilter | undefined;
};

/**
 * Describes the message grpc.api.v1.ContactFilterListResponse.
 * Use `create(ContactFilterListResponseSchema)` to create a new message.
 */
export const ContactFilterListResponseSchema: GenMessage<ContactFilterListResponse> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 9);

/**
 * EditorTemplateService
 *
 * @generated from message grpc.api.v1.EditorTemplateRequest
 */
export type EditorTemplateRequest = Message<"grpc.api.v1.EditorTemplateRequest"> & {
  /**
   * @generated from field: grpc.api.v1.EditorTemplate editorTemplate = 1;
   */
  editorTemplate?: EditorTemplate | undefined;
};

/**
 * Describes the message grpc.api.v1.EditorTemplateRequest.
 * Use `create(EditorTemplateRequestSchema)` to create a new message.
 */
export const EditorTemplateRequestSchema: GenMessage<EditorTemplateRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 10);

/**
 * @generated from message grpc.api.v1.EditorTemplateIdRequest
 */
export type EditorTemplateIdRequest = Message<"grpc.api.v1.EditorTemplateIdRequest"> & {
  /**
   * @generated from field: int64 id = 2;
   */
  id: bigint;
};

/**
 * Describes the message grpc.api.v1.EditorTemplateIdRequest.
 * Use `create(EditorTemplateIdRequestSchema)` to create a new message.
 */
export const EditorTemplateIdRequestSchema: GenMessage<EditorTemplateIdRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 11);

/**
 * @generated from message grpc.api.v1.EditorTemplateListRequest
 */
export type EditorTemplateListRequest = Message<"grpc.api.v1.EditorTemplateListRequest"> & {
};

/**
 * Describes the message grpc.api.v1.EditorTemplateListRequest.
 * Use `create(EditorTemplateListRequestSchema)` to create a new message.
 */
export const EditorTemplateListRequestSchema: GenMessage<EditorTemplateListRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 12);

/**
 * @generated from message grpc.api.v1.EditorTemplateResponse
 */
export type EditorTemplateResponse = Message<"grpc.api.v1.EditorTemplateResponse"> & {
  /**
   * @generated from field: grpc.api.v1.EditorTemplate editorTemplate = 1;
   */
  editorTemplate?: EditorTemplate | undefined;
};

/**
 * Describes the message grpc.api.v1.EditorTemplateResponse.
 * Use `create(EditorTemplateResponseSchema)` to create a new message.
 */
export const EditorTemplateResponseSchema: GenMessage<EditorTemplateResponse> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 13);

/**
 * @generated from message grpc.api.v1.EditorTemplateListResponse
 */
export type EditorTemplateListResponse = Message<"grpc.api.v1.EditorTemplateListResponse"> & {
  /**
   * @generated from field: grpc.api.v1.EditorTemplate editorTemplate = 1;
   */
  editorTemplate?: EditorTemplate | undefined;
};

/**
 * Describes the message grpc.api.v1.EditorTemplateListResponse.
 * Use `create(EditorTemplateListResponseSchema)` to create a new message.
 */
export const EditorTemplateListResponseSchema: GenMessage<EditorTemplateListResponse> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 14);

/**
 * ContactManagerService
 *
 * @generated from message grpc.api.v1.SelectedContactsRequest
 */
export type SelectedContactsRequest = Message<"grpc.api.v1.SelectedContactsRequest"> & {
  /**
   * @generated from field: repeated int64 ids = 2;
   */
  ids: bigint[];
};

/**
 * Describes the message grpc.api.v1.SelectedContactsRequest.
 * Use `create(SelectedContactsRequestSchema)` to create a new message.
 */
export const SelectedContactsRequestSchema: GenMessage<SelectedContactsRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 15);

/**
 * @generated from message grpc.api.v1.MergeContactsRequest
 */
export type MergeContactsRequest = Message<"grpc.api.v1.MergeContactsRequest"> & {
  /**
   * @generated from field: grpc.api.v1.Contact contact = 1;
   */
  contact?: Contact | undefined;

  /**
   * @generated from field: repeated int64 ids = 2;
   */
  ids: bigint[];

  /**
   * @generated from field: grpc.api.v1.Employee employee = 3;
   */
  employee?: Employee | undefined;
};

/**
 * Describes the message grpc.api.v1.MergeContactsRequest.
 * Use `create(MergeContactsRequestSchema)` to create a new message.
 */
export const MergeContactsRequestSchema: GenMessage<MergeContactsRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 16);

/**
 * @generated from message grpc.api.v1.DeleteContactsRequest
 */
export type DeleteContactsRequest = Message<"grpc.api.v1.DeleteContactsRequest"> & {
  /**
   * @generated from field: repeated int64 ids = 2;
   */
  ids: bigint[];

  /**
   * @generated from field: grpc.api.v1.Employee employee = 3;
   */
  employee?: Employee | undefined;
};

/**
 * Describes the message grpc.api.v1.DeleteContactsRequest.
 * Use `create(DeleteContactsRequestSchema)` to create a new message.
 */
export const DeleteContactsRequestSchema: GenMessage<DeleteContactsRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 17);

/**
 * @generated from message grpc.api.v1.SearchContactsRequest
 */
export type SearchContactsRequest = Message<"grpc.api.v1.SearchContactsRequest"> & {
  /**
   * @generated from field: string filter = 1;
   */
  filter: string;
};

/**
 * Describes the message grpc.api.v1.SearchContactsRequest.
 * Use `create(SearchContactsRequestSchema)` to create a new message.
 */
export const SearchContactsRequestSchema: GenMessage<SearchContactsRequest> = /*@__PURE__*/
  messageDesc(file_contact_manager_service, 18);

/**
 * @generated from service grpc.api.v1.ContactService
 */
export const ContactService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.ContactService.get
   */
  get: {
    methodKind: "unary";
    input: typeof ContactIdRequestSchema;
    output: typeof ContactResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactService.create
   */
  create: {
    methodKind: "unary";
    input: typeof ContactRequestSchema;
    output: typeof ContactResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactService.update
   */
  update: {
    methodKind: "unary";
    input: typeof ContactRequestSchema;
    output: typeof ContactResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactService.delete
   */
  delete: {
    methodKind: "unary";
    input: typeof ContactIdRequestSchema;
    output: typeof ContactResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactService.list
   */
  list: {
    methodKind: "server_streaming";
    input: typeof ContactListRequestSchema;
    output: typeof ContactListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_contact_manager_service, 0);

/**
 * @generated from service grpc.api.v1.ContactFilterService
 */
export const ContactFilterService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.ContactFilterService.get
   */
  get: {
    methodKind: "unary";
    input: typeof ContactFilterIdRequestSchema;
    output: typeof ContactFilterResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactFilterService.create
   */
  create: {
    methodKind: "unary";
    input: typeof ContactFilterRequestSchema;
    output: typeof ContactFilterResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactFilterService.update
   */
  update: {
    methodKind: "unary";
    input: typeof ContactFilterRequestSchema;
    output: typeof ContactFilterResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactFilterService.delete
   */
  delete: {
    methodKind: "unary";
    input: typeof ContactFilterIdRequestSchema;
    output: typeof ContactFilterResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactFilterService.list
   */
  list: {
    methodKind: "server_streaming";
    input: typeof ContactFilterListRequestSchema;
    output: typeof ContactFilterListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_contact_manager_service, 1);

/**
 * @generated from service grpc.api.v1.EditorTemplateService
 */
export const EditorTemplateService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.EditorTemplateService.get
   */
  get: {
    methodKind: "unary";
    input: typeof EditorTemplateIdRequestSchema;
    output: typeof EditorTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.EditorTemplateService.create
   */
  create: {
    methodKind: "unary";
    input: typeof EditorTemplateRequestSchema;
    output: typeof EditorTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.EditorTemplateService.update
   */
  update: {
    methodKind: "unary";
    input: typeof EditorTemplateRequestSchema;
    output: typeof EditorTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.EditorTemplateService.delete
   */
  delete: {
    methodKind: "unary";
    input: typeof EditorTemplateIdRequestSchema;
    output: typeof EditorTemplateResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.EditorTemplateService.list
   */
  list: {
    methodKind: "server_streaming";
    input: typeof EditorTemplateListRequestSchema;
    output: typeof EditorTemplateListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_contact_manager_service, 2);

/**
 * @generated from service grpc.api.v1.ContactManagerService
 */
export const ContactManagerService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.ContactManagerService.selectedContacts
   */
  selectedContacts: {
    methodKind: "server_streaming";
    input: typeof SelectedContactsRequestSchema;
    output: typeof ContactListResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactManagerService.mergeContacts
   */
  mergeContacts: {
    methodKind: "server_streaming";
    input: typeof MergeContactsRequestSchema;
    output: typeof ContactListResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactManagerService.deleteContacts
   */
  deleteContacts: {
    methodKind: "server_streaming";
    input: typeof DeleteContactsRequestSchema;
    output: typeof ContactListResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.ContactManagerService.searchContacts
   */
  searchContacts: {
    methodKind: "server_streaming";
    input: typeof SearchContactsRequestSchema;
    output: typeof ContactListResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_contact_manager_service, 3);

